/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArbeitszeitkontoDto } from '../../models/arbeitszeitkonto-dto';

export interface GetArbeitszeitkontosForMitarbeiter$Plain$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;
  Start: string;
  End: string;
}

export function getArbeitszeitkontosForMitarbeiter$Plain(http: HttpClient, rootUrl: string, params: GetArbeitszeitkontosForMitarbeiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArbeitszeitkontoDto>>> {
  const rb = new RequestBuilder(rootUrl, getArbeitszeitkontosForMitarbeiter$Plain.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.query('Start', params.Start, {});
    rb.query('End', params.End, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ArbeitszeitkontoDto>>;
    })
  );
}

getArbeitszeitkontosForMitarbeiter$Plain.PATH = '/v1/mitarbeiter/{mitarbeiterId}/arbeitszeitkonten';
